import { render } from "./RenewableProjectRegion.vue?vue&type=template&id=38538d31"
import script from "./RenewableProjectRegion.vue?vue&type=script&lang=js"
export * from "./RenewableProjectRegion.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__